import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { prepareAssets } from './utils/prepareAssets';
import { getTemplateByID } from '../DocSignature/helper';
import DocEdit from './DocEdit';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col, Container, Navbar, NavbarBrand, Row } from 'reactstrap';

const EditTemplate = () => {
    const { t } = useTranslation();
    let { id, template_id } = useParams();
    const [templateData, setTemplateData] = useState<any>([]);
    const moduleHeading = t('Edit template');
    document.title = `${moduleHeading} | ` + process.env.REACT_APP_NAME;
    useEffect(() => {
        if (id && template_id) {
            getTemplate(id, template_id);
            prepareAssets();
        }
    }, []);

    const getTemplate = async (id: any, doc_id: any) => {
        const result = await getTemplateByID(id, doc_id);
        if (result.status == "success" && result.data) {
            setTemplateData(result?.data);
        }
    }


    return (
        <div className={"page-content"}>
            <Container fluid>
                <Row>
                    <Col xl="12">
                        <Card>
                            <CardBody>
                                <Navbar light expand="md">
                                    <NavbarBrand href="/">{t("Edit document")}</NavbarBrand>
                                </Navbar>
                                <DocEdit id={id} template_id={template_id} templateData={templateData} attachmentData={[]} type="template" />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div >
    )
}

export default EditTemplate